import React, { useState, useEffect } from "react";
import "./Adminprofile.css";
import { useDispatch, useSelector } from "react-redux";
import default_pfp from "../../../images/default_pfp.svg";
import { fetchProfileData } from "../../../Services/Profile/ProfileApi";
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

function AdminprofileComp() {
  const dispatch = useDispatch();
  const { data } = useSelector((state) => state.fetchProfileData);
  const [profile, setProfile] = useState({});
  const [loading, setLoading] = useState(true);
  const [userEmail, setuseremail] = useState();
  const userId = localStorage.getItem("user_id");
  const userType = localStorage.getItem("user_type");
 
  // const phone_number=localStorage.getItem(phone_number)




  const navigate = useNavigate();

  useEffect(() => {
    dispatch(fetchProfileData(userId)).finally(() => setLoading(false));
  }, [dispatch]);

  useEffect(() => {
    if (data) {
      setProfile(data.user_details);
      setuseremail(data?.user_details?.email);
    }
  }, [data]);

  const handleSendEmail = () => {
    if (data) {
      navigate(`/change-password?email=${encodeURIComponent(userEmail)}`); // Pass email as a query parameter
    }
  };

  const handleUpdateProfile = () => {
    navigate("/super-admin/update-admin", { state: { profileData: data } });
  };

  return (
    <>
      <div className="admin-profile-section">
        <div className="back-btn">
          <button onClick={() => navigate(-1)} className="back-btn-button">
            <ArrowBackIcon className="left-icon" />
            Back
          </button>
        </div>
        <div className="admin-profile-wrapper">
          <div className="admin-profile-inner">
            <div className="admin-content-block d-flex">
              <div className="admin-pic-name">
                <div className="admin-img">
                  <img
                    src={profile?.image || "https://cdn-icons-png.flaticon.com/128/18781/18781453.png"}
                    alt="Profile-picture"
                    onError={(e) => {
                      e.target.onerror = null; // Prevent infinite loop
                      e.target.src = default_pfp; // Fallback image
                    }}
                  />
                </div>
                <div className="admin-name text-center">
                  {profile?.first_name} {profile?.last_name}
                </div>
                <div className="admin-designation text-center">{userType}</div>
              </div>
              <div className="admin-main-details">
                <div className="personal-details">Personal Details</div>
                <div className="table-admin">
                  <div className="table-admin-inner">
                    <table class="table table-borderless table-desktop-view">
                      <thead>
                        <tr>
                          <th scope="col">First Name</th>
                          <th scope="col">Last Name</th>
                          <th scope="col">Email address</th>
                          <th scope="col">&nbsp;</th>
                          <th scope="col">Phone Number</th>

                          {/* <th scope="col">Location</th> */}
                        </tr>
                      </thead>
                      <tbody >
                       
                        <tr>
                       
                          
                          <td>{data?.data?.first_name} </td>
                          <td>{data?.data?.last_name}</td>
                          <td>{data?.data?.email}</td>
                          <td>&nbsp;</td>
                          <td>{data?.data?.phone_number}</td>
                          {/* <td>{data?.data.location}</td> */}
                        </tr>
                      </tbody>
                    </table>
                    {/* <table class="table table-borderless table-mobile-view">
                      <tbody>
                        <tr className="d-grid row-superadmin">
                          <td>{profile?.first_name} </td>
                          <td>{profile?.last_name}</td>
                          <td>{profile?.email}</td>
                          <td className="ph_number">{profile?.phone_number}</td>
                        </tr>
                      </tbody>
                    </table> */}
                  </div>
                </div>
              </div>
            </div>
            <div className="change-edit-btns d-flex gap-3 justify-content-center ">
              {/* <div className="change-pw-btn text-end mt-3">
                <button onClick={handleSendEmail}>Change Password</button>
              </div> */}
              {/* <div className="editprofile-btn text-end mt-3">
                <button onClick={handleUpdateProfile}>  Edit  </button>
              </div> */}
               <div className="editprofile-btn text-end mt-3">
                <button onClick={handleUpdateProfile}>  Edit  </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AdminprofileComp;
